import React, { useCallback, useEffect, useState } from "react";
import { AdvancedMarker, Map, MapCameraChangedEvent, MapMouseEvent } from "@vis.gl/react-google-maps";
import config from "../MapConfig";

interface LatLng {
  lat: number;
  lng: number;
}

interface CameraProps {
  center: LatLng;
  zoom: number;
}

interface MapComponentProps {
  onDataFromMap: (data: LatLng) => void;
  lati: number;
  lngi: number;
}

const GOYA_DEFAULT = { lat: -29.14383470536903, lng: -59.26513140291266 };

const MapComponent: React.FC<MapComponentProps> = ({ onDataFromMap, lati, lngi }) => {
  const MAP_ID = config.MAP_ID;

  // Estado unificado para la cámara y el marcador
  const [cameraProps, setCameraProps] = useState<CameraProps>({
    center: GOYA_DEFAULT,
    zoom: 18
  });

  const [markerPos, setMarkerPos] = useState<LatLng>(GOYA_DEFAULT);

  // Sincronizar el mapa cuando cambian las coordenadas desde el Autocomplete (lati/lngi)
  useEffect(() => {
    const lat = parseFloat(String(lati));
    const lng = parseFloat(String(lngi));

    if (!isNaN(lat) && !isNaN(lng)) {
      const newPos = { lat, lng };
      setMarkerPos(newPos);
      setCameraProps((prev) => ({ ...prev, center: newPos }));
    }
  }, [lati, lngi]);

  // Manejar el movimiento manual de la cámara
  const handleCameraChange = useCallback((ev: MapCameraChangedEvent) => {
    setCameraProps(ev.detail as CameraProps);
  }, []);

  // Manejar el click en el mapa para mover el marcador manualmente
  const handleMapClick = (event: MapMouseEvent) => {
    if (event.detail.latLng) {
      const newPosition = {
        lat: event.detail.latLng.lat,
        lng: event.detail.latLng.lng,
      };
      setMarkerPos(newPosition);
      onDataFromMap(newPosition);
    }
  };

  return (
    <Map
      {...cameraProps}
      onCameraChanged={handleCameraChange}
      onClick={handleMapClick}
      mapId={MAP_ID}
      style={{ height: "50vh", width: "100%", borderRadius: "12px" }}
      // Props opcionales para mejor UX
      disableDefaultUI={false}
      gestureHandling={'greedy'}
    >
      <AdvancedMarker position={markerPos} />
    </Map>
  );
};

export default MapComponent;